import { useMutation } from '@tanstack/react-query';
import { MMEApi } from '../../../apis/MMEApi/MMEApi.ts';
import { IMMECalculationRequest, IMMECalculationResult } from '../MME.ts';

export function useCalculateMME() {
    return useMutation<IMMECalculationResult, Error, IMMECalculationRequest>({
        mutationFn: async (request: IMMECalculationRequest) => {
            return await MMEApi.calculateMME(request);
        },
    });
}

